<div *ngIf="showCreateSection">
  <div class="p-fluid">
    <div class="p-field">
      <label for="name">Name*</label>
      <input
        (keydown.enter)="handleSaveProject(projectNameInput.value)"
        #projectNameInput
        type="text"
        pInputText
        [disabled]="isSaving"
      />
    </div>
    <div class="p-field-checkbox shared-checkbox-field">
      <p-checkbox
        id="shared"
        [(ngModel)]="shared"
        [binary]="true"
        [disabled]="isSaving"
      ></p-checkbox>
      <label for="shared">Shared with Account?</label>
    </div>
  </div>
  <div class="box-button-right">
    <p-button
      [disabled]="!projectNameInput.value || isSaving"
      [icon]="isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-check'"
      type="button"
      [label]="isSaving ? 'Saving' : 'Save'"
      class="p-mr-2 create"
      (click)="handleSaveProject(projectNameInput.value)"
    ></p-button>
    <p-button
      icon="pi pi-times"
      type="button"
      label="Cancel"
      styleClass="p-button-raised p-button-secondary p-button-text"
      (click)="handleCancelProject()"
    ></p-button>
  </div>
</div>
